"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useTimer;

var _react = require("react");

function useTimer(at, fn) {
  (0, _react.useEffect)(function () {
    if (typeof at === 'number') {
      var timeout = setTimeout(fn, Math.max(0, at - Date.now()));
      return function () {
        return clearTimeout(timeout);
      };
    }
  }, [at, fn]);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy9pbnRlcm5hbC91c2VUaW1lci5qcyJdLCJuYW1lcyI6WyJ1c2VUaW1lciIsImF0IiwiZm4iLCJ0aW1lb3V0Iiwic2V0VGltZW91dCIsIk1hdGgiLCJtYXgiLCJEYXRlIiwibm93IiwiY2xlYXJUaW1lb3V0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBRWUsU0FBU0EsUUFBVCxDQUFrQkMsRUFBbEIsRUFBc0JDLEVBQXRCLEVBQTBCO0FBQ3ZDLHdCQUFVLFlBQU07QUFDZCxRQUFJLE9BQU9ELEVBQVAsS0FBYyxRQUFsQixFQUE0QjtBQUMxQixVQUFNRSxPQUFPLEdBQUdDLFVBQVUsQ0FBQ0YsRUFBRCxFQUFLRyxJQUFJLENBQUNDLEdBQUwsQ0FBUyxDQUFULEVBQVlMLEVBQUUsR0FBR00sSUFBSSxDQUFDQyxHQUFMLEVBQWpCLENBQUwsQ0FBMUI7QUFFQSxhQUFPO0FBQUEsZUFBTUMsWUFBWSxDQUFDTixPQUFELENBQWxCO0FBQUEsT0FBUDtBQUNEO0FBQ0YsR0FORCxFQU1HLENBQUNGLEVBQUQsRUFBS0MsRUFBTCxDQU5IO0FBT0QiLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHVzZUVmZmVjdCB9IGZyb20gJ3JlYWN0JztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlVGltZXIoYXQsIGZuKSB7XG4gIHVzZUVmZmVjdCgoKSA9PiB7XG4gICAgaWYgKHR5cGVvZiBhdCA9PT0gJ251bWJlcicpIHtcbiAgICAgIGNvbnN0IHRpbWVvdXQgPSBzZXRUaW1lb3V0KGZuLCBNYXRoLm1heCgwLCBhdCAtIERhdGUubm93KCkpKTtcblxuICAgICAgcmV0dXJuICgpID0+IGNsZWFyVGltZW91dCh0aW1lb3V0KTtcbiAgICB9XG4gIH0sIFthdCwgZm5dKTtcbn1cbiJdfQ==